import * as THREE from 'three';

const bodyMaterial = new THREE.MeshStandardMaterial({ color: '#e8d9b8', roughness: 0.8 });
const roofMaterial = new THREE.MeshStandardMaterial({ color: '#c0533f', roughness: 0.6 });

export function createHouse(position: THREE.Vector3, scale = 1): THREE.Group {
  const group = new THREE.Group();

  const body = new THREE.Mesh(new THREE.BoxGeometry(1.4, 1.2, 1.4), bodyMaterial);
  body.position.y = 0.6;
  body.castShadow = true;
  body.receiveShadow = true;
  group.add(body);

  const roof = new THREE.Mesh(new THREE.ConeGeometry(1.15, 0.9, 4), roofMaterial);
  roof.position.y = 1.65;
  roof.rotation.y = Math.PI / 4;
  roof.castShadow = true;
  group.add(roof);

  group.position.copy(position);
  group.scale.setScalar(scale);
  return group;
}

export function disposeHouseMaterials(): void {
  bodyMaterial.dispose();
  roofMaterial.dispose();
}
